import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import {
    ErrorHandlerContribution,
    ErrorHandlerRegistry,
    ErrorHandlerRegistryImpl,
    ErrorHandler,
    ErrorHandlerImpl,
    bindContributionProvider,
} from '@patsnap/tahiti-core';
import { DraftingErrorHandler } from '@/services/error-handler/impls/error-handler';
import { GlossaryUploadErrorHandler } from '@/services/error-handler/impls/glossary-upload-error-handler';

export const errorHandlerModule = new ContainerModule((bind) => {
    bind(ErrorHandler).to(ErrorHandlerImpl);
    bind(ErrorHandlerRegistry).to(ErrorHandlerRegistryImpl);
    bindContributionProvider(bind, ErrorHandlerContribution);
    bind(ErrorHandlerContribution).to(GlossaryUploadErrorHandler);
    bind(ErrorHandlerContribution).to(DraftingErrorHandler);
});
